let windowVHeight = window.innerHeight;
async function setvh() {
    const vh = await window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    windowVHeight = vh;
};
setvh();

/* navigation header */
let previousScrollY = 0;
const bodyElement = document.querySelector('body');
function classToggle(toggleElement, className) {
    toggleElement.classList.toggle(className);
}

document.querySelector('.menu-toggle').addEventListener('click', function() {
    classToggle(bodyElement, 'menuopen');

    if (bodyElement.classList.contains('menuopen')) {
        previousScrollY = window.scrollY;
        bodyElement.style.position = 'fixed';
    } else {
        bodyElement.style.position = 'initial';
        window.scrollTo(0, previousScrollY);
    }
});

/* window resize */
const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

window.addEventListener('resize', function() {
    const vh = window.innerHeight * 0.01;
    if (windowVHeight !== vh) {
        windowVHeight = vh;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    }

    if (!mq.matches && bodyElement.classList.contains('menuopen')) {
        bodyElement.classList.remove('menuopen');
        bodyElement.style.position = 'initial';
        window.scrollTo(0, previousScrollY);
    }
});